import React, { useState } from "react";
import styles from "./UPSCMathematics.module.css";

const UPSCMathematicsPYQ = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // PYQ data from 2000 to 2025 (descending order) - 26 rows
  // Simply copy and paste your Google Drive links in the fields below
  const pyqData = [
    // 2025
    {
      id: 1,
      year: 2025,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2025",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2025_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2025_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2025",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2025_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2025_ID/view" // Paste Paper II view link here
      }
    },
    // 2024
    {
      id: 2,
      year: 2024,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2024",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2024_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2024_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2024",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2024_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2024_ID/view" // Paste Paper II view link here
      }
    },
    // 2023
    {
      id: 3,
      year: 2023,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2023",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2023_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2023_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2023",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2023_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2023_ID/view" // Paste Paper II view link here
      }
    },
    // 2022
    {
      id: 4,
      year: 2022,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2022",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2022_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2022_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2022",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2022_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2022_ID/view" // Paste Paper II view link here
      }
    },
    // 2021
    {
      id: 5,
      year: 2021,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2021",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2021_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2021_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2021",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2021_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2021_ID/view" // Paste Paper II view link here
      }
    },
    // 2020
    {
      id: 6,
      year: 2020,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2020",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2020_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2020_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2020",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2020_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2020_ID/view" // Paste Paper II view link here
      }
    },
    // 2019
    {
      id: 7,
      year: 2019,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2019",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2019_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2019_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2019",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2019_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2019_ID/view" // Paste Paper II view link here
      }
    },
    // 2018
    {
      id: 8,
      year: 2018,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2018",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2018_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2018_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2018",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2018_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2018_ID/view" // Paste Paper II view link here
      }
    },
    // 2017
    {
      id: 9,
      year: 2017,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2017",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2017_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2017_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2017",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2017_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2017_ID/view" // Paste Paper II view link here
      }
    },
    // 2016
    {
      id: 10,
      year: 2016,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2016",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2016_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2016_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2016",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2016_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2016_ID/view" // Paste Paper II view link here
      }
    },
    // 2015
    {
      id: 11,
      year: 2015,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2015",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2015_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2015_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2015",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2015_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2015_ID/view" // Paste Paper II view link here
      }
    },
    // 2014
    {
      id: 12,
      year: 2014,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2014",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2014_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2014_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2014",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2014_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2014_ID/view" // Paste Paper II view link here
      }
    },
    // 2013
    {
      id: 13,
      year: 2013,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2013",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2013_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2013_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2013",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2013_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2013_ID/view" // Paste Paper II view link here
      }
    },
    // 2012
    {
      id: 14,
      year: 2012,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2012",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2012_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2012_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2012",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2012_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2012_ID/view" // Paste Paper II view link here
      }
    },
    // 2011
    {
      id: 15,
      year: 2011,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2011",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2011_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2011_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2011",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2011_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2011_ID/view" // Paste Paper II view link here
      }
    },
    // 2010
    {
      id: 16,
      year: 2010,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2010",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2010_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2010_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2010",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2010_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2010_ID/view" // Paste Paper II view link here
      }
    },
    // 2009
    {
      id: 17,
      year: 2009,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2009",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2009_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2009_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2009",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2009_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2009_ID/view" // Paste Paper II view link here
      }
    },
    // 2008
    {
      id: 18,
      year: 2008,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2008",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2008_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2008_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2008",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2008_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2008_ID/view" // Paste Paper II view link here
      }
    },
    // 2007
    {
      id: 19,
      year: 2007,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2007",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2007_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2007_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2007",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2007_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2007_ID/view" // Paste Paper II view link here
      }
    },
    // 2006
    {
      id: 20,
      year: 2006,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2006",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2006_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2006_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2006",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2006_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2006_ID/view" // Paste Paper II view link here
      }
    },
    // 2005
    {
      id: 21,
      year: 2005,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2005",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2005_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2005_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2005",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2005_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2005_ID/view" // Paste Paper II view link here
      }
    },
    // 2004
    {
      id: 22,
      year: 2004,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2004",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2004_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2004_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2004",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2004_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2004_ID/view" // Paste Paper II view link here
      }
    },
    // 2003
    {
      id: 23,
      year: 2003,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2003",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2003_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2003_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2003",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2003_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2003_ID/view" // Paste Paper II view link here
      }
    },
    // 2002
    {
      id: 24,
      year: 2002,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2002",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2002_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2002_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2002",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2002_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2002_ID/view" // Paste Paper II view link here
      }
    },
    // 2001
    {
      id: 25,
      year: 2001,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2001",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2001_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2001_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2001",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2001_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2001_ID/view" // Paste Paper II view link here
      }
    },
    // 2000
    {
      id: 26,
      year: 2000,
      paper1: {
        title: "UPSC Mathematics Optional Paper - I 2000",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER1_2000_ID", // Paste Paper I link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER1_2000_ID/view" // Paste Paper I view link here
      },
      paper2: {
        title: "UPSC Mathematics Optional Paper - II 2000",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_PAPER2_2000_ID", // Paste Paper II link here
        viewLink: "https://drive.google.com/file/d/YOUR_PAPER2_2000_ID/view" // Paste Paper II view link here
      }
    }
  ];

  // Filter years based on search
  const filteredData = pyqData.filter(item => 
    item.year.toString().includes(searchTerm)
  );

  // Download handler
  const handleDownload = (link) => {
    window.open(link, "_blank");
  };

  // View handler
  const handleView = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.pyqPage}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            UPSC Mathematics Optional <span className={styles.gradient}>PYQs</span>
          </h1>
          <p className={styles.subtitle}>
            2000 - 2025 • 26 Years • Paper I & Paper II
          </p>
        </div>

        {/* Search Bar */}
        <div className={styles.searchSection}>
          <div className={styles.searchBox}>
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Search by year (e.g., 2024)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button 
                className={styles.clearBtn}
                onClick={() => setSearchTerm("")}
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </div>

        {/* Results Count */}
        <div className={styles.resultsInfo}>
          <span>Showing {filteredData.length} of {pyqData.length} years</span>
          <span className={styles.orderInfo}>(2025 → 2000)</span>
        </div>

        {/* PYQ Table - One row per year */}
        <div className={styles.tableWrapper}>
          <table className={styles.pyqTable}>
            <thead>
              <tr>
                <th>Year</th>
                <th>UPSC Mathematics Optional Paper - I</th>
                <th>UPSC Mathematics Optional Paper - II</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id} className={styles.tableRow}>
                    {/* Year Column */}
                    <td className={styles.yearCell}>
                      <span className={styles.yearBadge}>{item.year}</span>
                    </td>
                    
                    {/* Paper I Column */}
                    <td className={styles.paperCell}>
                      <div className={styles.paperContent}>
                        <span className={styles.paperTitle}>
                          <i className="fas fa-file-pdf"></i>
                          {item.paper1.title}
                        </span>
                        <div className={styles.buttonGroup}>
                          <button 
                            className={styles.viewBtn}
                            onClick={() => handleView(item.paper1.viewLink)}
                            title="View PDF"
                          >
                            <i className="fas fa-eye"></i>
                            View
                          </button>
                          <button 
                            className={styles.downloadBtn}
                            onClick={() => handleDownload(item.paper1.downloadLink)}
                            title="Download PDF"
                          >
                            <i className="fas fa-download"></i>
                            Download
                          </button>
                        </div>
                      </div>
                    </td>
                    
                    {/* Paper II Column */}
                    <td className={styles.paperCell}>
                      <div className={styles.paperContent}>
                        <span className={styles.paperTitle}>
                          <i className="fas fa-file-pdf"></i>
                          {item.paper2.title}
                        </span>
                        <div className={styles.buttonGroup}>
                          <button 
                            className={styles.viewBtn}
                            onClick={() => handleView(item.paper2.viewLink)}
                            title="View PDF"
                          >
                            <i className="fas fa-eye"></i>
                            View
                          </button>
                          <button 
                            className={styles.downloadBtn}
                            onClick={() => handleDownload(item.paper2.downloadLink)}
                            title="Download PDF"
                          >
                            <i className="fas fa-download"></i>
                            Download
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className={styles.noData}>
                    <div className={styles.noDataContent}>
                      <i className="fas fa-search"></i>
                      <p>No results found for "{searchTerm}"</p>
                      <button 
                        className={styles.resetBtn}
                        onClick={() => setSearchTerm("")}
                      >
                        Clear Search
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* REMOVED: Download All Section */}
      </div>
    </div>
  );
};

export default UPSCMathematicsPYQ;